import "./styles.scss";
import { ReactComponent as LeftCurl } from "../../assets/curl_left.svg";
import { ReactComponent as RightCurl } from "../../assets/curl_right.svg";
import LOGO3 from "../../assets/logob.webp";
import { useEffect } from "react";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import { gsap } from "gsap";

import ColorBlocks from "../ColorBlock/ColorBlocks";

export const NavbarMobile = () => {
  useEffect(() => {
    gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

    gsap
      .timeline({
        scrollTrigger: {
          trigger: "#intro",
          start: "0% 25%",
          end: "12% 25%",
          scrub: true,
        },
      })
      .to(".navbarContainerMobile", {
        backgroundColor: "black",
        height: "150px",
      });
  }, []);

  return (
    <div className="Navbar">
      <div className="navbarContainerMobile">
        <div className="blockContainerMobile" style={{}}>
          <ColorBlocks />
        </div>
        <nav className="navbarWrapperMobile">
          <LeftCurl className="curl left " />
          <img className="logo" alt="logo" src={LOGO3} />
          <RightCurl className="curl right " />
        </nav>
      </div>
    </div>
  );
};
